import * as packageJson from '../../package.json'

export const spxxVersion = packageJson.version
